import { z } from 'zod';

export const funnelOverviewSummarySchema = z.object({
  brand: z.string().optional(),
  verticalCategory: z.string().optional(),
  productType: z.string().optional(),
  funnelType: z.string().optional(),
  visualFormat: z.string().optional(),
  narrativeStructure: z.string().optional(),
  primaryConversionGoal: z.string().optional(),
  trafficIntentMatch: z.string().optional(),
  primaryOffer: z.string().optional(),
  offerMechanic: z.string().optional(),
  recommendedCtaStyle: z.string().optional(),
  primaryCtaCopy: z.string().optional(),
  ctaPlacementPattern: z.string().optional(),
  checkoutTransition: z.string().optional(),
  frictionBand: z.string().optional(),
  dropOffRisk: z.string().optional(),
  primaryDropoffRisk: z.string().optional(),
  secondaryDropoffRisks: z.array(z.string()).optional(),
  trustGap: z.string().optional(),
  offerClarity: z.string().optional(),
  mobileRisk: z.string().optional(),
  complianceRisk: z.string().optional(),
  primaryProofMechanism: z.string().optional(),
  socialProofDensity: z.string().optional(),
  objectionHandling: z.string().optional(),
  guaranteeOrReversal: z.string().optional(),
  urgencyScarcity: z.string().optional(),
  templateFitScore: z.number().min(0).max(100).optional(),
  recommendedTemplate: z.string().optional(),
  missingTemplateSlots: z.array(z.string()).optional(),
});

export const FunnelOverviewSummarySchema = funnelOverviewSummarySchema;

export type FunnelOverviewSummary = z.infer<
  typeof funnelOverviewSummarySchema
>;
